import { zodResolver } from '@hookform/resolvers/zod';
import CT from '@marketplace-ai/tags';
import { FormProvider } from 'react-hook-form';
import {
  Button,
  FormActions,
  FormLayout,
  FormRow as Row,
  FormSection as Section,
  Select,
  TextArea,
} from '~/components';
import { useCustomForm } from '~/hooks/useCustomForm';
import { DETAIL_LABELS_OPTIONS, emptyDetailsForm } from '../constants';
import { detailSchema } from '../schemas';
import { DetailFormValues } from '../types';
const TAGS = CT.academics.education.detailForm;

interface FormProps {
  addDetail: (values: DetailFormValues) => void;
}

export const DetailForm = (props: FormProps) => {
  const { addDetail } = props;
  const methods = useCustomForm<DetailFormValues>({
    resolver: zodResolver(detailSchema),
    defaultValues: emptyDetailsForm,
  });
  const { trigger, getValues } = methods;

  const handleButton = async () => {
    // Since this is a form within a form, if you handleSubmit here, it will fire both forms at once.
    const isValid = await trigger();
    if (isValid) {
      addDetail(getValues());
    }
  };

  return (
    <FormProvider {...methods}>
      <form data-cy={TAGS.form} id="detail-form">
        <FormLayout>
          <Section componentsPerLine={1}>
            <Row>
              {/* [MCV-1260] Both fields are required by `detailSchema`; surface
                  the asterisk so it matches the "is visibly required" UX. */}
              <Select
                name={'fieldLabel'}
                label={'Information Type'}
                cyTag={TAGS.fieldLabelSelect}
                options={DETAIL_LABELS_OPTIONS}
                required
              />
            </Row>
          </Section>
          <Section componentsPerLine={1}>
            <Row>
              <TextArea
                cyTag={TAGS.fieldTxtInput}
                name={'fieldTxt'}
                label={'Explanation'}
                description={'Please provide any clarifying details'}
                required
              />
            </Row>
          </Section>
          <FormActions>
            <Button
              type="button"
              cyTag={TAGS.submitBtn}
              label={'Add Detail to Education'}
              onClick={handleButton}
            />
          </FormActions>
        </FormLayout>
      </form>
    </FormProvider>
  );
};
